import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadRFPPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'アプリ開発 RFP 提案依頼書 ベンダー選定 要件定義'}
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/rfp/done/'}
          title="ご入力いただきありがとうございます | アプリ開発RFP作成のポイント | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="アプリ開発において、ベンダーの真価を引き出す「RFP（提案依頼書）」作成のポイントを解説 。手段ではなく「解決したい課題」を伝える実践的な書き方をご紹介します 。そのまま実務で使える無料テンプレート付き！"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
